import { mapStyles } from "./config";
import { PIN_DEFAULT } from "./pins";

export const schoolsMarkerLayer = {
  id: "schools-marker",
  type: "symbol",
  filter: ["!=", ["get", "pin_type"], "Case Study"],
  "symbol-z-order": "source",
  minzoom: 7,
  layout: {
    "icon-allow-overlap": true,
    "icon-size": 0.6,
    "icon-image": PIN_DEFAULT,
    "text-anchor": "top",
  }
};

export const caseStudiesMarkerLayer = {
  id: "case-studies-marker",
  type: "symbol",
  filter: ["==", ["get", "pin_type"], "Case Study"],
  "symbol-z-order": "source",
  minzoom: 7,
  layout: {
    "icon-allow-overlap": true,
    "icon-size": 0.4,
    "icon-image": "case-study-star",
    "text-anchor": "top",
  }
};

export const schoolsMarkerHoverLayer = {
  id: "schools-marker-hover",
  type: "symbol",
  minzoom: 7,
  layout: {
    "icon-allow-overlap": true,
    "icon-size": 0.8,
    "icon-image": PIN_DEFAULT,
    "text-anchor": "top",
  }
};

export const schoolsClusterLayer = {
  id: "schools-cluster",
  type: "circle",
  filter: ["has", "point_count"],
  paint: {
    "circle-color": [
      "step",
      ["get", "point_count"],
      mapStyles.clusterTier1Color,
      10,
      mapStyles.clusterTier2Color,
      50,
      mapStyles.clusterTier3Color,
      100,
      mapStyles.clusterTier4Color,
      501,
      mapStyles.clusterTier5Color,
    ],
    "circle-radius": [
      "step",
      ["get", "point_count"],
      20,
      50,
      23,
      99,
      26,
      249,
      30,
    ],
    "circle-stroke-width": 3,
    "circle-stroke-color": "#ffffff",
  },
  minzoom: 5,
  maxzoom: 7
};

export const schoolsClusterCountLayer = {
  id: "cluster-count",
  type: "symbol",
  filter: ["has", "point_count"],
  layout: {
    "text-field": "{point_count_abbreviated}",
    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
    "text-size": 14,
  },
  paint: {
    "text-color": "#2B345F",
  },
  minzoom: 5,
  maxzoom: 7
};

export const clustersHoverLayer1 = {
  id: "clusters-hover-1",
  type: "circle",
  filter: ["==", "id", ""],
  paint: {
    "circle-radius": 23,
    "circle-color": mapStyles.clusterTier1Color,
    "circle-opacity": 1,
    "circle-stroke-width": 3,
    "circle-stroke-color": "#ffffff",
    "circle-radius-transition": { duration: 200 },
  },
  minzoom: 5,
  maxzoom: 7
};

export const clustersHoverLayer2 = {
  id: "clusters-hover-2",
  type: "circle",
  filter: ["==", "id", ""],
  paint: {
    "circle-radius": 26,
    "circle-color": mapStyles.clusterTier2Color,
    "circle-opacity": 1,
    "circle-stroke-width": 3,
    "circle-stroke-color": "#ffffff",
    "circle-radius-transition": { duration: 200 },
  },
  minzoom: 5,
  maxzoom: 7
};

export const clustersHoverLayer3 = {
  id: "clusters-hover-3",
  type: "circle",
  filter: ["==", "id", ""],
  paint: {
    "circle-radius": 30,
    "circle-color": mapStyles.clusterTier3Color,
    "circle-opacity": 1,
    "circle-stroke-width": 3,
    "circle-stroke-color": "#ffffff",
    "circle-radius-transition": { duration: 200 },
  },
  minzoom: 5,
  maxzoom: 7
};

export const clustersHoverLayer4 = {
  id: "clusters-hover-4",
  type: "circle",
  filter: ["==", "id", ""],
  paint: {
    "circle-radius": 33,
    "circle-color": mapStyles.clusterTier4Color,
    "circle-opacity": 1,
    "circle-stroke-width": 3,
    "circle-stroke-color": "#ffffff",
    "circle-radius-transition": { duration: 200 },
  },
  minzoom: 5,
  maxzoom: 7
};

export const schoolsCircleLayer = {
  id: "schools-circle",
  type: "symbol",
  minzoom: 5,
  maxzoom: 7,
  layout: {
    "icon-allow-overlap": true,
    "icon-size": 0.7,
    "icon-image": "singlecluster-gray",
    "text-anchor": "top",
  },
};

export const schoolsCircleHoverLayer = {
  id: "schools-circle-hover",
  type: "symbol",
  source: "schools",
  minzoom: 5,
  maxzoom: 7,
  layout: {
    "icon-allow-overlap": true,
    "icon-size": 0.8,
    "icon-image": "singlecluster-gray",
    "text-anchor": "top",
  },
};

export const stateHoverLayer = {
  id: "state-hover",
  type: "line",
  source: "states-data",
  layout: {},
  paint: {
    "line-color": "#FFFFFF",
    "line-width": 2,
  },
};

export const activeStateLayer = {
  id: "active-state",
  type: "line",
  source: "states-data",
  layout: {},
  paint: {
    "line-color": "#FFFFFF",
    "line-width": 2,
  },
};

export const stateBordersSchoolsLayer = {
  id: "state-borders-schools",
  type: "line",
  source: "states-data",
  layout: {},
  paint: {
    "line-color": mapStyles.stateLayerStrokeColor,
    "line-width": 1,
  },
};

export const stateBordersStatesLayer = {
  id: "state-borders-schools",
  type: "line",
  source: "states-data",
  layout: {},
  paint: {
    "line-color": mapStyles.schoolLayerStrokeColor,
    "line-width": 1,
  },
};

export const stateFillsCapacity = {
  id: "state-fills-capacity",
  type: "fill",
  source: "states-data",
  layout: {},
  paint: {
    "fill-color": [
      "step",
      ["get", "total_solar_school_energy_capacity"],
      mapStyles.legendTier1Color,
      1000,
      mapStyles.legendTier2Color,
      5000,
      mapStyles.legendTier3Color,
      10000,
      mapStyles.legendTier4Color,
      15000,
      mapStyles.legendTier5Color,
      30000,
      mapStyles.legendTier6Color,
      50000,
      mapStyles.legendTier7Color,
    ],
  },
};

export const stateFillsPercentSchools = {
  id: "state-fills-percent-schools",
  type: "fill",
  source: "states-data",
  layout: {},
  paint: {
    "fill-color": [
      "step",
      ["get", "percent_solar_schools"],
      mapStyles.legendTier1Color,
      5,
      mapStyles.legendTier2Color,
      10,
      mapStyles.legendTier3Color,
      15,
      mapStyles.legendTier4Color,
      20,
      mapStyles.legendTier5Color,
    ],
  },
};

export const stateFillsNumberSolarSchools = {
  id: "state-fills-number-solar-schools",
  type: "fill",
  source: "states-data",
  layout: {},
  paint: {
    "fill-color": [
      "step",
      ["get", "number_solar_schools"],
      mapStyles.legendTier1Color,
      25,
      mapStyles.legendTier2Color,
      50,
      mapStyles.legendTier3Color,
      100,
      mapStyles.legendTier4Color,
      150,
      mapStyles.legendTier5Color,
      250,
      mapStyles.legendTier6Color,
      500,
      mapStyles.legendTier7Color,
    ],
  },
};


export const stateAllDistrictBorders = {
  id: "state-all-district-borders",
  type: "line",
  source: "all-district-data",
  layout: {},
  paint: {
    "line-color": "#B9B9B9",
    "line-width": 1,
  },
};

export const stateDistrictBorders = {
  id: "state-district-borders",
  type: "line",
  source: "district-data",
  layout: {},
  paint: {
    "line-color": "#B9B9B9",
    "line-width": 1,
  },
};

export const stateActiveDistrictBorder = {
  id: "state-active-district-border",
  type: "line",
  source: "district-data",
  layout: {},
  paint: {
    "line-color": "#333333",
    "line-width": 2,
  },
};

export const stateDistrictFillsCapacity = {
  id: "state-district-fills-capacity",
  type: "fill",
  source: "district-data",
  layout: {},
  paint: {
    "fill-color": [
      "case",
      ["==", ["get", "total_solar_school_energy_capacity"], 0],
      "#FFFFFF",
      [
        "step",
        ["get", "total_solar_school_energy_capacity"],
        mapStyles.legendTier1Color,
        1,
        mapStyles.legendTier2Color,
        51,
        mapStyles.legendTier3Color,
        250,
        mapStyles.legendTier4Color,
        500,
        mapStyles.legendTier5Color,
        1000,
        mapStyles.legendTier6Color,
      ],
    ],
  },
};

export const stateDistrictFills = {
  id: "state-district-fills",
  type: "fill",
  source: "district-data",
  layout: {},
  paint: {
    "fill-color": "#FFFFFF",
  },
};

export const stateBorderLayer = {
  id: "state-border",
  type: "line",
  source: "states",
  layout: {},
  paint: {
    "line-color": "#B9B9B9",
    "line-width": 2,
  },
};
